import React from 'react';
import {cancelRectangleSelection}  from './region_select';
import { datareadStore ,datasetStore, videoStore} from '../managers/globalState';
import { useSnapshot } from 'valtio';
// import { useParams, useLocation } from 'react-router-dom';
const CancelRectangleButton = () => {
  const { hasSelectedRegion } = useSnapshot(datareadStore.state);
    // const { state } = useLocation();
    // const { notFirstPage } = state ?? {};
    // const { currentDataset, currentVS } = useSnapshot(datasetStore.state);
    // const visibleEarthIds = ['viirsToday', 'modisToday', 'modisAquaToday'];
      // const isVisibleEarth = visibleEarthIds.includes(currentDataset?.externalId);
      //  const { currentVideo, isVideoTexture } = useSnapshot(videoStore.state);
    //  const isSatellites = currentVS?.value === 'satellites';
      // const isVisible = Boolean(currentDataset) && !isVisibleEarth && !isSatellites  && !currentVideo && !isVideoTexture;
      // console.log("cancel button", hasSelectedRegion, notFirstPage, Boolean(currentDataset),currentVideo,isVideoTexture  )
  // if (!hasSelectedRegion) return null;
  
  return hasSelectedRegion&&(
    <button
      id="cancel_select"
      className="rectangle-btn"
      onClick={cancelRectangleSelection}
      style={{
        // backgroundColor: '#cc0000',
        // color: 'white',
        // border: 'none',
        // borderRadius: '4px',
        //marginRight: '100px',
        // padding: '8px 12px',
        // cursor: 'pointer'
                  backgroundColor: '#2a5e96',
          color: '#fff',
          fontSize: '14px',
          fontWeight: 500,
          height: '32px',
          lineHeight: '20px',
          marginTop: '14px',
          padding: '0 12px',
          textTransform: 'none',
          width: '100%',
      }}
    >
      إلغاء
    </button>
  );
};

export default CancelRectangleButton;
